// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"0ccbdb6b447da7749307","339":"6392c618460af42080b4"}[chunkId] + ".js";
};